import { WarehouseZone } from '../../../../services/inventory/types';

export const getZoneParentFromZone = (warehouseZone: WarehouseZone) =>
  warehouseZone.parentWarehouseZone ? `${warehouseZone.parentWarehouseZone.name} > ` : '';

export const getZoneNameFromZone = (warehouseZone?: WarehouseZone) =>
  warehouseZone ? `${getZoneParentFromZone(warehouseZone)}${warehouseZone.name}` : '';

export const getZoneParentById = (warehouseZones?: WarehouseZone[], zoneId?: number | null) => {
  const parent = warehouseZones?.find(zone => zone.id === zoneId)?.name;
  return parent ? `${parent} > ` : '';
};

export const getZoneNameById = (warehouseZones?: WarehouseZone[], zoneId?: number | null) => {
  const zone = warehouseZones?.find(zone => zone.id === zoneId);
  return zone ? `${getZoneParentById(warehouseZones, zone.parentWarehouseZoneId)}${zone.name}` : '';
};

const STATUS_COLORS = {
  completed: 'success.main',
  success: 'success.main',
  failed: 'error.main',
  'in progress': 'warning.main',
  processing: 'warning.main',
  pending: 'info.main',
  'no action': 'text.secondary',
} as const;

export const getStatusColor = (status: string) =>
  STATUS_COLORS[status as keyof typeof STATUS_COLORS] || 'text.secondary';
